import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, Subscription, take } from 'rxjs';
import { JsonDataService } from '../../../../services/json-data/json-data.service';
import { GameOverlayService } from '../../../../services/game-overlay/game-overlay.service';
import { SignialsService } from '../../../../services/signals/signials.service';
import { SPINE_KEYS } from '../../../../constants/textures';
import { GameUiService } from '../../../../services/game-ui/game-ui.service';
import { RowCard } from '../../../ui/base/row-cards/row-cards.component';
import { CardSectionType } from '../../../ui/base/result-card/result-card.component';
import { GameContext } from '../../../../services/game-ui/game-context.enum';
import { AssetExtService } from '../../../../services/asset-ext.service';
import { AudioService } from '../../../../services/audio/audio.service';

export interface FearsDetail {
	main: string;
	title: string;
	desc: string;
	img: string;
	id: number;
	endDialog: string;
	why: string;
	result: string;
	help: string[];
	try: string;
	how: string;
	recomDesc?: string;
	recom: string[];
}
@Component({
  selector: 'app-witch',
	providers: [
		JsonDataService,
	],
  templateUrl: './witch.component.html',
  styleUrl: './witch.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WitchComponent implements OnInit, OnDestroy {
	@Output()
	showPhrase: EventEmitter<string> = new EventEmitter();
	@Output()
	closeModal: EventEmitter<void> = new EventEmitter();
	@Output()
	finishGame: EventEmitter<string[]> = new EventEmitter();

	showMiniGame = true;
	showDetail = false;
	selectedCard: FearsDetail;

	fearsCards: FearsDetail[] = [];
	cards: RowCard[];

	showCards = false;
	showAnswerBook = false;

	subs: Subscription[] = [];

	cardOpened = false;

	selected: RowCard;

	isShow= false;
	constructor(
		private overlay: GameOverlayService,
		private cdr: ChangeDetectorRef,
		private signal: SignialsService,
		private jsonData: JsonDataService,
		private ui: GameUiService,
		private assetExt: AssetExtService,
		private audio: AudioService
	) {}

	ngOnInit(): void {
		const gender = localStorage.getItem('gender') || 'female';
		this.overlay.hideSpeaker();
		this.jsonData.loadJson<FearsDetail[]>('witch/fears').subscribe(data => {
			this.fearsCards = data;
			this.cards = this.fearsCards.map(c => {
				if (c.recomDesc)
					return {
					color: '#654146',
					title: c.main,
					subtitle: c.title,
					resultImg: `assets-compressed/categories/witch/cards/${gender}/${this.assetExt.getBackgroundImageUrlSync(c.img)}`,
					resultData: [
						{
							text: [c.desc],
							type: CardSectionType.Simple,
						},
						{
							text: ['mb-1'],
							type: CardSectionType.Space
						},
						{
							text: ['Как проявляется:'],
							type: CardSectionType.Subtitle,
						},
						{
							text: ['mb-1 sm:mb-1'],
							type: CardSectionType.Space
						},
						{
							text: [c.how],
							type: CardSectionType.Simple,
						},
						{
							text: ['mb-1'],
							type: CardSectionType.Space
						},
						{
							text: ['Рекомендации:'],
							type: CardSectionType.Title2,
						},
						{
							text: ['mb-1 sm:mb-1'],
							type: CardSectionType.Space
						},
						{
							text: [c.recomDesc],
							type: CardSectionType.Simple,
						},
						{
							text: ['mb-1 sm:mb-1'],
							type: CardSectionType.Space
						},
						{
							text: c.recom,
							type: CardSectionType.List,
						},
					],
				}
				else return {
					color: '#654146',
					title: c.main,
					subtitle: c.title,
					resultImg: `assets-compressed/categories/witch/cards/${gender}/${this.assetExt.getBackgroundImageUrlSync(c.img)}`,
					resultData: [
						{
							text: [c.desc],
							type: CardSectionType.Simple,
						},
						{
							text: ['mb-1'],
							type: CardSectionType.Space
						},
						{
							text: ['Как проявляется:'],
							type: CardSectionType.Subtitle,
						},
						{
							text: ['mb-1 sm:mb-1'],
							type: CardSectionType.Space
						},
						{
							text: [c.how],
							type: CardSectionType.Simple,
						},
						{
							text: ['mb-1'],
							type: CardSectionType.Space
						},
						{
							text: ['Рекомендации:'],
							type: CardSectionType.Title2,
						},
						{
							text: ['mb-1 sm:mb-1'],
							type: CardSectionType.Space
						},
						{
							text: c.recom,
							type: CardSectionType.List,
						},
					],
				}
			});
		});

		const subs = this.ui.skipClicked$.pipe(debounceTime(300)).subscribe(() => {
      if (!this.showMiniGame && !this.signal.dialogActive$.value) this.finish();
    });
		const s = this.ui.skipInteractiveClicked$.pipe(debounceTime(300)).subscribe(() => {
			this.finish(false);
		});
		this.subs.push(subs);
	}


	ngOnDestroy(): void {
		// this.subs.unsubscribe();
		this.subs.forEach(el => {
			el.unsubscribe();
		})
	}

	showDetailCard(card: FearsDetail) {
		this.selectedCard = card;
		this.showDetail = true;
		this.cdr.detectChanges();
	}
	closeDetailCard() {
		this.showPhrase.emit(this.selectedCard.endDialog);
		this.showDetail = false;
		const s = this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
			this.showAnswerBook = true;
			this.cdr.detectChanges();
		});
		this.subs.push(s);
		this.cdr.detectChanges();
	}

	closeMiniGame(success?: boolean) {
		this.ui.setContext(GameContext.GameWitch);
		this.overlay.showSpeaker();

		this.showPhrase.emit('successFinishMiniGame');
		const s = this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
			this.ui.isGameInteractive = true;
			this.showCards = true;
			this.cdr.detectChanges();
		});
		this.subs.push(s);
		setTimeout(() => {
			this.showMiniGame = false;
			this.cdr.detectChanges();
		}, 100);
	}

	closeBook() {
		this.showAnswerBook = false;
		this.cdr.detectChanges();
	}
	closed() {
		this.overlay.hideOverlay(true);
		this.closeModal.emit();
	}
	saveResult() {
		this.finishGame.emit([SPINE_KEYS.witch, 'true']);
	}
	finish(success: boolean = true) {
		this.ui.isGameInteractive = false;
		
		this.showCards = false;
		this.cdr.detectChanges();
		this.showPhrase.emit('exit');
		const s = this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
			this.closeModal.emit();
			this.cdr.detectChanges();
		});
		this.subs.push(s);
	}
	
  playClick() {
    this.audio.playCardOfDoubts();
  }

	selectCard(card) {
		this.selected = card;
		setTimeout(() => {
			this.isShow = true;
			this.cdr.detectChanges();
		}, 100)
		this.cdr.detectChanges();
	}

	openCard() {
		this.cardOpened = true;
		this.cdr.detectChanges();
	}
}
